module.exports = __webpack_public_path__ + "media/metronic/_theme/media/users/300_4-a0261f72e06c111610b701a96572a6ee.jpg";